<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5dEWHg/images/cover.jpg?1684514748908" alt="This image is the cover for the book Historic Milwaukee Public Schoolhouses, Landmarks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Historic Milwaukee Public Schoolhouses, Landmarks
      </h1>
      <p class="bookDescription body article font2">
        <p>It's no surprise we feel a connection to our schools, where we learn to read, write and forge social bonds of all kinds. They are potentially the scenes of our first crushes (and the second and third). They are where we learn to create ourselves. For more than a century, Milwaukee has taken its schoolhouses seriously, and it has a matchless variety of gorgeous landmarks to prove it. Robert Tanzilo pays homage to some long-lost schools, salutes some veteran survivors and examines the roles they play in their neighborhoods. Learn a little about some remarkable Milwaukee architects and see what the future may hold for some of the city's most beloved old buildings.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Tanzilo
      </h2>
      
      <p class="authorDescription body article">Milwaukee resident Robert Tanzilo is managing editor at OnMilwaukee.com, a daily online city magazine, and creator of the site SchoolMattersMKE.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32e97332